import React from "react";
import "./allowable.css";
import Search from "./sub-allowable/Search";
import AllowableContent from "./sub-allowable/Allowable-Content";
import Quantity from "./sub-allowable/Quantity";

function Allowable () {
    return(
        <div className="container mainactualemp">
            <div className="row">
                <div className="col-12 ActuaEmp">
                    < Search title={"Planned vs Allowable vs Actual"}/>
                    < AllowableContent />
                </div>
                <div className="QutySec">
                < Quantity />
                </div>
            </div>
        </div>
    )
};

export default Allowable ;